import { createAction } from '@reduxjs/toolkit';

export const getDesignByItem = createAction('GET_DESIGN_BY_ITEM');
export const setDesignDetails = createAction('SET_DESIGN_DETAILS');

export const loadConfiguratorOptions = createAction('LOAD_CONFIGURATOR_OPTIONS');

export const UPDATE_CONFIG = 'UPDATE_CONFIG';
export const UPDATE_ISCOPY = 'UPDATE_ISCOPY';
export const UPDATE_LINEITEM = 'UPDATE_LINEITEM';
export const UPDATE_THD_STORE_INFO = 'UPDATE_THD_STORE_INFO';
export const SUMMARY_DRAWER_OPEN = 'SUMMARY_DRAWER_OPEN';

export const UPDATE_STEPS = 'UPDATE_STEPS';
export const EDIT_STEPS = 'EDIT_STEPS';
export const ADD_STEPS = 'ADD_STEPS';
export const CONFIRM_STEPS = 'CONFIRM_STEPS';
export const QUESTION_ANSWERED = 'QUESTION_ANSWERED';

export const GET_PRICING = 'GET_PRICING';
export const getPricing = createAction(GET_PRICING);
export const savePricing = createAction('SAVE_PRICING');
export const saveUpdatedChoices = createAction('SAVE_UPDATED_CHOICES');
export const setLoadMoreVisible = createAction('SET_LOAD_MORE_VISIBLE');
export const setLoadMoreToggle = createAction('SET_LOAD_MORE_TOGGLE');
export const setOmsIdFromUrl = createAction('SET_OMS_ID_FROM_URL');

export const updateSelectedChoice = createAction('UPDATE_SELECTED_CHOICE');
export const updateCarpetPrice = createAction('UPDATE_CARPET_PRICE');
export const updateStairsPrice = createAction('UPDATE_STEP_PRICE');
export const updateStairsPadPrice = createAction('UPDATE_STEP_PAD_PRICE');
export const updateCarpetPadChoices = createAction('UPDATE_CARPET_PAD_CHOICES');
export const currentCarpetPadChoices = createAction('CURRENT_CARPET_PAD_CHOICES');
export const getSelectedCarpetPad = createAction('GET_SELECTED_CARPET_PAD');

export const setSelectedCarpetSort = createAction('SET_SELECTED_CARPET_SORT');
export const persistDesign = createAction('PERSIST_SELECTIONS_FROM_DESIGN');
// design Actions
export const BEGIN_DESIGN_IS_LOADING = 'BEGIN_DESIGN_IS_LOADING';
export const beginLoadingDesign = createAction(BEGIN_DESIGN_IS_LOADING);
export const END_DESIGN_IS_LOADING = 'END_DESIGN_IS_LOADING';
export const endLoadingDesign = createAction(END_DESIGN_IS_LOADING);
//
export const DISMISS_LOADING = 'DISMISS_PERSIST_SELECTIONS_LOADING';
export const dismissLoading = createAction(DISMISS_LOADING);
export const CREATE_DESIGN = 'CREATE_DESIGN';
export const CREATE_DESIGN_FAILED = 'CREATE_DESIGN_FAILED';
export const UPDATE_ITEM_PRODUCT = 'UPDATE_ITEM_PRODUCT';
export const UPDATE_ITEM_PRODUCT_FAILED = 'UPDATE_ITEM_PRODUCT_FAILED';
export const GET_DESIGN_BY_ITEM = 'GET_DESIGN_BY_ITEM';
export const GET_DESIGN_BY_ITEM_FAILED = 'GET_DESIGN_BY_ITEM_FAILED';
export const ENABLE_SAVE = 'ENABLE_SAVE';
export const DISABLE_SAVE = 'DISABLE_SAVE';
export const SAVE_CONFIG_START = 'SAVE_CONFIG_START';
export const SAVE_CONFIG_SUCCESS = 'SAVE_CONFIG_SUCCESS';
export const SAVE_CONFIG_FAILED = 'SAVE_CONFIG_FAILED';
export const SAVE_ONLINE_DESIGN_SUCCESS = 'SAVE_ONLINE_DESIGN_SUCCESS';
export const SAVE_ONLINE_DESIGN_FAILED = 'SAVE_ONLINE_DESIGN_FAILED';
export const SEND_DESIGN_EMAIL_SUCCESS = 'SEND_DESIGN_EMAIL_SUCCESS';
export const SEND_DESIGN_EMAIL_FAILED = 'SEND_DESIGN_EMAIL_FAILED';
export const setGuidedOptionFilter = createAction('SET_GUIDED_OPTION_FILTER');
export const initGuidedOptionFilter = createAction('INIT_GUIDED_OPTION_FILTER');
export const SET_IS_FROM_SAVE = 'IS_FROM_SAVE';
export const SET_PILOT_STORE = 'SET_PILOT_STORE';
export const SET_REGIONAL_SELECTIONS = 'SET_REGIONAL_SELECTIONS';
export const SET_CURRENT_STORE = 'SET_CURRENT_STORE';
export const savePricingDetailsFromThd = createAction('SAVE_PRICING_DETAILS_FROM_THD');

export const setSelections = createAction('SET_SELECTIONS');
export const CHOICE_SELECTED = 'CHOICE_SELECTED';
export const onSelectedChoice = createAction(CHOICE_SELECTED);
export const UPDATE_CHOICES = 'UPDATE_CHOICES';
export const updateChoices = createAction(UPDATE_CHOICES);
export const setAvailableChoices = createAction('SET_AVAILABLE_CHOICES');

export const updateConfigProductId = createAction('UPDATE_PRODUCT_ID');
